import React, { useEffect, useState } from "react";
import InputRadio from "../../../../components/InputRadio";
import { getIndexFromObjectArray } from "../../../../helpers/helpers";
import { getUser } from "../../../../services/auth";

const MultiplePercentage = ({param, productParams, setProductParams}) => {
    const user = getUser();
    const [index, setIndex] = useState(null);
    const [options, setOptions] = useState([]);
    // Duas opções distintas podem ter o mesmo valor calculado (ex.: "TX 50%
    // s/BV" e "TX 55% s/BV" = 50%) — o InputRadio marca "ativo" comparando
    // por value, então rastreamos qual descrição foi de fato escolhida à
    // parte, pra não marcar várias opções ao mesmo tempo (BDM-1020). O que é
    // salvo em productParams continua sendo só o valor numérico, como sempre.
    const [selectedDescription, setSelectedDescription] = useState(null);

    useEffect(() => {
        let toIndex = getIndexFromObjectArray(productParams, 'id', param.id);
        setIndex(toIndex);
    }, [productParams]);

    useEffect(() => {
        getOptions();
    }, [param])

    // Ao abrir um item já existente, deriva a opção ativa a partir do valor
    // salvo (só na primeira vez — cai na primeira opção com esse valor, que é
    // a mesma ambiguidade de antes, mas só até o usuário escolher de novo).
    useEffect(() => {
        if (index === null || selectedDescription !== null || !options.length) return;
        let currentValue = productParams[index]?.value;
        let match = options.find(option => option.value === currentValue);
        if (match) setSelectedDescription(match.description);
    }, [index, options]);

    const getOptions = () => {
        let toOptions = param.options.filter(option => option.admin_ids.length === 0 ? true : option.admin_ids.includes(user.id));
        setOptions(toOptions);
    }

    const handleParamChange = description => {
        let selectedOption = options.find(option => option.description === description);
        if (!selectedOption) return;

        setSelectedDescription(description);
        setProductParams(prev => {
            let toProductParams = [...prev];
            toProductParams[index].value = selectedOption.value;
            return toProductParams;
        });
    }

    return (
        <>
            {index !== null &&
                <>
                    <div className="modal-section-title">
                        <div className="left">
                            <h2>{param.name}</h2>
                        </div>
                    </div>
                    <div className="section">
                        {/* Não usa createOptions aqui: ele deduplica pelo value, e
                            duas opções distintas podem ter o mesmo valor calculado
                            (ex.: "TX 50% s/BV" e "TX 55% s/BV" = 50%) — cada uma
                            precisa continuar aparecendo (BDM-1020). Usa a descrição
                            (única por opção) como value do radio, não o valor
                            calculado, pra marcar só a opção certa como ativa. */}
                        <InputRadio
                            className="four-columns"
                            options={options.map(option => ({ label: option.description, value: option.description }))}
                            value={selectedDescription}
                            change={handleParamChange}
                        />
                    </div>
                </>
            }
        </>
    );
}

export default MultiplePercentage;